import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=ab74f1f6&scoped=true&"
import script from "./Code.vue?vue&type=script&lang=js&"
export * from "./Code.vue?vue&type=script&lang=js&"
import style0 from "./Code.vue?vue&type=style&index=0&id=ab74f1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab74f1f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab74f1f6')) {
      api.createRecord('ab74f1f6', component.options)
    } else {
      api.reload('ab74f1f6', component.options)
    }
    module.hot.accept("./Code.vue?vue&type=template&id=ab74f1f6&scoped=true&", function () {
      api.rerender('ab74f1f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/Code.vue"
export default component.exports